import { ExportCallLogsResponse } from '../call-log-service/call-log-service.types';
import { getRequest, postRequest } from '../request/request.service';
import {
  AnalyticsCallsResponse,
  Annotation,
  AnnotationContext,
  AnnotationPayload,
  RecordingUrlResponse,
} from './conversations-service.types';

export function getAnalyticCall({ analytics_call_id, translate }: AnnotationContext) {
  return getRequest<AnalyticsCallsResponse>(`/conversations/${analytics_call_id}`, {
    params: { translate },
  });
}

export function postAnnotation(params: AnnotationContext, data: AnnotationPayload) {
  return postRequest<Annotation>(`/conversations/${params.analytics_call_id}/annotations`, {
    data,
  });
}

export function getTxtFile(id: number) {
  return getRequest<ExportCallLogsResponse>(`/conversations/${id}/download_transcription`, {
    headers: { Accept: 'text/csv' },
    responseType: 'text',
  });
}

export function reviewedConversation(params: AnnotationContext, reviewed: boolean) {
  return postRequest<Annotation>(`/conversations/${params.analytics_call_id}/review_conversation`, {
    data: { reviewed },
  });
}

export function getRecordingUrl(conversationId: number) {
  return getRequest<RecordingUrlResponse>(`/conversations/${conversationId}/get_recording_url`);
}
